import React from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import ShoppingCartRoundedIcon from "@material-ui/icons/ShoppingCartRounded";
import Menu from "./Menu"
import { toogleDrawer } from "../actions/authActions";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MailIcon from "@material-ui/icons/Mail";
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import HomeRoundedIcon from "@material-ui/icons/HomeRounded";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import ContactsRoundedIcon from "@material-ui/icons/ContactsRounded";
import StoreRoundedIcon from "@material-ui/icons/StoreRounded";
import InfoRoundedIcon from "@material-ui/icons/InfoRounded";
import { NavLink } from "react-router-dom";
import {
    TextField,
    Button,
    Card,
    Container,
    CardActions,
} from "@material-ui/core";
import { connect } from "react-redux";
import Footer from "./Footer";

import CardActionArea from "@material-ui/core/CardActionArea";

import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import StarsIcon from "@material-ui/icons/Stars";

import Paper from "@material-ui/core/Paper";
import InstagramEmbed from "react-instagram-embed";
import CircularProgress from "@material-ui/core/CircularProgress";
import clsx from "clsx";
import FavoriteIcon from "@material-ui/icons/Favorite";
import ShareIcon from "@material-ui/icons/Share";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import IconButton from "@material-ui/core/IconButton";
import Collapse from "@material-ui/core/Collapse";
import Grid from "@material-ui/core/Grid";
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    lolroot: {
        display: "flex",
    },
    root: {
        marginTop: "5rem",
        // maxWidth: 345,
        align: "center",
    },
    media: {
        height: 0,
        paddingTop: "56.25%", // 16:9
    },
    expand: {
        transform: "rotate(0deg)",
        marginLeft: "auto",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: "rotate(180deg)",
    },
    avatar: {
        // backgroundColor: red[500],
    },
    nav: {
        textDecoration: "none",
        color: "inherit",
    },
    drawer: {
        [theme.breakpoints.up("sm")]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    appBar: {

    },

    menuButton: {
        marginRight: theme.spacing(2),

    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        width: drawerWidth,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
}));

function About(props) {
    const { window } = props;
    const classes = useStyles();
    const theme = useTheme();
    const [mobileOpen, setMobileOpen] = React.useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };
    const [expanded, setExpanded] = React.useState(false);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const drawer = (
        <div>
            <div className={classes.toolbar} />
            <Divider />
            <List>
                <NavLink to="/" className={classes.nav}>
                    <ListItem button>
                        <ListItemIcon>
                            <HomeRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={"Home"} />
                    </ListItem>
                </NavLink>
                <NavLink to="/shop" className={classes.nav}>
                    <ListItem button>
                        <ListItemIcon>
                            <StoreRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={"Shop"} />
                    </ListItem>
                </NavLink>
                {props.auth.isAuthenticated ? (
                    <NavLink to="/cart" className={classes.nav}>
                        <ListItem button>
                            <ListItemIcon>
                                <ShoppingCartRoundedIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText primary={"Cart"} />
                        </ListItem>
                    </NavLink>
                ) : null}
                {props.auth.isAuthenticated ? (
                    <NavLink to="/wishlist" className={classes.nav}>
                        <ListItem button>
                            <ListItemIcon>
                                <StarsIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText primary={"Wishlist"} />
                        </ListItem>
                    </NavLink>
                ) : null}

                <NavLink to="/contact" className={classes.nav}>
                    <ListItem button>
                        <ListItemIcon>
                            <ContactsRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={"Contact Us"} />
                    </ListItem>
                </NavLink>
                <NavLink to="/about" className={classes.nav}>
                    <ListItem button selected={true}>
                        <ListItemIcon>
                            <InfoRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={"About Us"} />
                    </ListItem>
                </NavLink>
            </List>
        </div>
    );

    const container =
        window !== undefined ? () => window().document.body : undefined;

    return (
        <div
        // className={classes.lolroot}
        >
            <CssBaseline />
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={() => props.toogleDrawer()}
                        className={classes.menuButton}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography
                        variant="h6"
                        align="center"
                        // noWrap
                        style={{
                            fontFamily: " 'Berkshire Swash', cursive",
                            // border: "1px solid",
                            width: "100%",
                        }}
                    >
                        {props.website.website
                            ? props.website.website.header
                            : ""}
                    </Typography>
                </Toolbar>
            </AppBar>
            <Menu />
            <main className={classes.content}>



                <Container maxWidth="sm" className={classes.root}>
                    <Typography
                        align="center"
                        variant="h6"
                        color="secondary"
                    >
                        Designed & Developed By
                        </Typography>
                    <Divider
                        variant="middle"
                        style={{ marginTop: "1rem" }}
                    />

                    {/* <Divider variant='middle' style={{ marginTop: '1rem' }} /> */}
                    <Card style={{ marginTop: "1rem" }}>
                        {/* <CardActionArea>
            <CardContent> */}
                        <Grid
                            container
                            direction="row"
                            justify="flex-start"
                            alignItems="center"
                        >
                            <Grid item xs={10}>
                                <Typography
                                    gutterBottom
                                    variant="h5"
                                    component="h2"
                                    align="center"
                                >
                                    Areeb Sayyed
                                    </Typography>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    component="p"
                                    align="center"
                                ></Typography>
                            </Grid>
                            {/* </CardContent>
          </CardActionArea> */}

                            <Grid item xs={2}>
                                <CardActions>
                                    <IconButton
                                        className={clsx(classes.expand, {
                                            [classes.expandOpen]: expanded,
                                        })}
                                        onClick={handleExpandClick}
                                        aria-expanded={expanded}
                                        aria-label="show more"
                                    >
                                        <ExpandMoreIcon />
                                    </IconButton>
                                </CardActions>
                            </Grid>

                            <Grid item xs={12}>
                                <Collapse
                                    in={expanded}
                                    timeout="auto"
                                    unmountOnExit
                                >
                                    <CardContent>
                                        <Typography paragraph>
                                            <InstagramEmbed
                                                url="https://www.instagram.com/p/BxM6H0ehVLp/?utm_source=ig_web_copy_link"
                                                maxWidth={550}
                                                // tyle={{ width: '100vw', border: '1px solid red' }}
                                                hideCaption={true}
                                                containerTagName="Card"
                                                protocol=""
                                                injectScript
                                                onLoading={() => { }}
                                                onSuccess={() => { }}
                                                onAfterRender={() => { }}
                                                onFailure={() => { }}

                                            // style={{ backgroundColor: 'black' }}
                                            />
                                        </Typography>
                                    </CardContent>
                                </Collapse>
                            </Grid>
                        </Grid>
                    </Card>
                    <Card style={{ marginTop: "1rem" }}>
                        {/* <CardActionArea>
            <CardContent> */}
                        <Grid
                            container
                            direction="row"
                            justify="flex-start"
                            alignItems="center"
                        >
                            <Grid item xs={10}>
                                <Typography
                                    gutterBottom
                                    variant="h5"
                                    component="h2"
                                    align="center"
                                >
                                    Vedant Mahewar
                                    </Typography>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    component="p"
                                    align="center"
                                ></Typography>
                            </Grid>
                            {/* </CardContent>
          </CardActionArea> */}

                            <Grid item xs={2}>
                                <CardActions>
                                    <IconButton
                                        className={clsx(classes.expand, {
                                            [classes.expandOpen]: expanded,
                                        })}
                                        onClick={handleExpandClick}
                                        aria-expanded={expanded}
                                        aria-label="show more"
                                    >
                                        <ExpandMoreIcon />
                                    </IconButton>
                                </CardActions>
                            </Grid>

                            <Grid item xs={12}>
                                <Collapse
                                    in={expanded}
                                    timeout="auto"
                                    unmountOnExit
                                >
                                    <CardContent>
                                        <Typography paragraph>
                                            <InstagramEmbed
                                                url="https://www.instagram.com/p/BqCsJzEhrlZ/?igshid=1xxkf5njuj8f5"
                                                maxWidth={550}
                                                // tyle={{ width: '100vw', border: '1px solid red' }}
                                                hideCaption={true}
                                                containerTagName="Card"
                                                protocol=""
                                                injectScript
                                                onLoading={() => { }}
                                                onSuccess={() => { }}
                                                onAfterRender={() => { }}
                                                onFailure={() => { }}

                                            // style={{ backgroundColor: 'black' }}
                                            />
                                        </Typography>
                                    </CardContent>
                                </Collapse>
                            </Grid>
                        </Grid>
                    </Card>
                    <Card style={{ marginTop: "1rem" }}>
                        {/* <CardActionArea>
            <CardContent> */}
                        <Grid
                            container
                            direction="row"
                            justify="flex-start"
                            alignItems="center"
                        >
                            <Grid item xs={10}>
                                <Typography
                                    gutterBottom
                                    variant="h5"
                                    component="h2"
                                    align="center"
                                >
                                    Harshit Shukla
                                    </Typography>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    component="p"
                                    align="center"
                                ></Typography>
                            </Grid>
                            {/* </CardContent>
          </CardActionArea> */}

                            <Grid item xs={2}>
                                <CardActions>
                                    <IconButton
                                        className={clsx(classes.expand, {
                                            [classes.expandOpen]: expanded,
                                        })}
                                        onClick={handleExpandClick}
                                        aria-expanded={expanded}
                                        aria-label="show more"
                                    >
                                        <ExpandMoreIcon />
                                    </IconButton>
                                </CardActions>
                            </Grid>

                            <Grid item xs={12}>
                                <Collapse
                                    in={expanded}
                                    timeout="auto"
                                    unmountOnExit
                                >
                                    <CardContent>
                                        <Typography paragraph>
                                            <InstagramEmbed
                                                url="https://www.instagram.com/p/B8XvtzAA7bH/?utm_source=ig_web_copy_link"
                                                maxWidth={550}
                                                // tyle={{ width: '100vw', border: '1px solid red' }}
                                                hideCaption={true}
                                                containerTagName="Card"
                                                protocol=""
                                                injectScript
                                                onLoading={() => { }}
                                                onSuccess={() => { }}
                                                onAfterRender={() => { }}
                                                onFailure={() => { }}

                                            // style={{ backgroundColor: 'black' }}
                                            />
                                        </Typography>
                                    </CardContent>
                                </Collapse>
                            </Grid>
                        </Grid>
                    </Card>

                    <Divider
                        variant="middle"
                        style={{ marginTop: "1rem" }}
                    />
                    <Typography
                        align="center"
                        variant="h6"
                        color="secondary"
                        style={{ marginTop: "1rem" }}
                    >
                        About Us
                        </Typography>
                    <Divider
                        variant="middle"
                        style={{ marginTop: "1rem" }}
                    />
                    {/* <Paper
                            variant="outlined"
                            elevation={3}
                            style={{ padding: "1rem" }}
                        >
                            <Typography align="center" variant="body1">
                                Social Book <br />
                                <Divider
                                    variant="middle"
                                    style={{
                                        marginTop: "1rem",
                                        marginBottom: "1rem",
                                    }}
                                />
                                A web application which provides you to share
                                your thoughts and quotes and explore your
                                creativity,
                                <br /> You can add your own commentary to texts,
                                share these ideas with others, follow others'
                                comments, and create communities of interactive
                                reader/writers.
                                <br />
                                We are here to give your writing skills your
                                thoughts a platform , You will explore , make
                                friends , share your thoughts,
                                <br /> and the best part is you will not be
                                judged by your looks and personality,
                                <br /> we believe in your talent and your
                                creativity.
                                <br /> so share your thoughts and stories.{" "}
                                <br />
                                thanks, <br />
                                kaal.
                            </Typography>
                        </Paper>
                       
                       */}

                    <Divider
                        variant="middle"
                        style={{ marginTop: "1rem" }}
                    />
                    <Paper
                        variant="outlined"
                        elevation={3}
                        style={{ padding: "1rem", marginTop: "1rem" }}
                    >
                        <Typography align="center" variant="body1">
                            Who are we ? <br />
                            <Divider
                                variant="middle"
                                style={{
                                    marginTop: "1rem",
                                    marginBottom: "1rem",
                                }}
                            />
                            <br />
                                We are the fast growing ,mumbai based company.
                                <br /> We want to create a platform for all the
                                writers and readers,
                                <br /> here's a platform where you can share
                                your creative thoughts and your own quote's
                                <br />
                                create interactive communities of readers and
                                writes and have greate conversation and explore
                                our application.
                                <br />
                                give us your valuable feedback in our
                                application (settings-->feedback).
                                <br />
                                Company Across India to make people follow there
                                passion.
                                <br /> thanks, <br />
                                kaal.
                            </Typography>
                    </Paper>
                    <Divider
                        variant="middle"
                        style={{ marginTop: "1rem" }}
                    />
                    <Typography
                        style={{ marginTop: "1rem" }}
                        align="center"
                        variant="h6"
                        color="secondary"
                    >
                        Powered By
                        </Typography>
                    <Card
                        style={{ marginTop: "1rem", marginBottom: "5rem" }}
                    >
                        <CardActionArea>
                            <CardContent>
                                <Typography
                                    gutterBottom
                                    variant="h5"
                                    component="h2"
                                    align="center"
                                >
                                    Kaal Group
                                    </Typography>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    component="p"
                                    align="center"
                                ></Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Container>

            </main>
        </div>
    );
}

const mapStateToProps = (state) => ({
    website: state.website,
    auth: state.auth,
});
export default connect(mapStateToProps, { toogleDrawer })(About);
